import { render, staticRenderFns } from "./vFormTextInput.vue?vue&type=template&id=05bbcaa2"
import script from "./vFormTextInput.vue?vue&type=script&lang=js"
export * from "./vFormTextInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports